// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SectionTitle_wrapper__XAdn2","title":"SectionTitle_title__Z1Gxp","view_center":"SectionTitle_view_center__WaJf7","view_right":"SectionTitle_view_right__gpnxV"};